import { render } from "./VerFacturaModal.vue?vue&type=template&id=6d0f2764&scoped=true"
import script from "./VerFacturaModal.vue?vue&type=script&lang=js"
export * from "./VerFacturaModal.vue?vue&type=script&lang=js"

import "./VerFacturaModal.vue?vue&type=style&index=0&id=6d0f2764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0f2764"]])

export default __exports__